import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { textFieldStyle } from "../../../assets/styles/styles";
export const IndexInput = ({ index, onIndexChange, ...props }) => {
    return (_jsx(TextField, { sx: textFieldStyle, label: "index", variant: "outlined", type: 'number', value: index, onChange: e => {
            try {
                onIndexChange(parseFloat(e.target.value));
            }
            catch (e) {
                onIndexChange(undefined);
            }
        }, ...props }, void 0));
};
//# sourceMappingURL=IndexInput.js.map